import { LayoutDashboard, FileText, Sparkles, BookOpen, Inbox, Users, Youtube, LogOut } from "lucide-react";

const items = [
  { id: "overview", label: "Aperçu & Stats", icon: LayoutDashboard, testid: "admin-nav-overview" },
  { id: "content", label: "Éditeur de Contenu", icon: FileText, testid: "admin-nav-content" },
  { id: "services", label: "Services & Formations", icon: Sparkles, testid: "admin-nav-services" },
  { id: "books", label: "Livres (PDF)", icon: BookOpen, testid: "admin-nav-books" },
  { id: "reservations", label: "Demandes & Contacts", icon: Inbox, testid: "admin-nav-reservations" },
  { id: "members", label: "Membres Le Cercle", icon: Users, testid: "admin-nav-members" },
  { id: "youtube", label: "Vidéos YouTube", icon: Youtube, testid: "admin-nav-youtube" },
];

export const AdminSidebar = ({ active, setActive, onLogout }) => (
  <aside className="w-full lg:w-72 shrink-0 bg-[#0D0D12] border-r border-amber-500/10 lg:min-h-screen p-5 lg:p-6">
    <div className="mb-8">
      <div className="font-serif text-xl gold-text">YoungspiritClub</div>
      <div className="text-[10px] tracking-[0.28em] uppercase text-amber-400/60 font-mono-accent">Admin Panel</div>
    </div>
    <nav className="flex lg:flex-col gap-1 overflow-x-auto">
      {items.map((it) => {
        const Icon = it.icon;
        const on = active === it.id;
        return (
          <button
            key={it.id}
            data-testid={it.testid}
            onClick={() => setActive(it.id)}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm whitespace-nowrap transition-colors ${
              on ? "bg-amber-500/15 text-amber-200 border border-amber-500/25" : "text-slate-400 hover:text-amber-200 hover:bg-white/5"
            }`}
          >
            <Icon size={18} /> <span className="hidden sm:inline">{it.label}</span>
          </button>
        );
      })}
    </nav>
    <button
      onClick={onLogout}
      data-testid="admin-logout-button"
      className="mt-6 hidden lg:flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-red-300/80 hover:bg-red-500/10 w-full transition-colors"
    >
      <LogOut size={18} /> Déconnexion
    </button>
  </aside>
);
